const routes = [
  {
    index: true,
    label: 'Mike Gartrell',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'CV',
    path: '/mike-cv.pdf',
    target: '_top',
  },
  // {
  //   label: 'Resume',
  //   path: '/resume',
  // },
  {
    label: 'Publications',
    path: '/publications',
  },
  // {
  //   label: 'Projects',
  //   path: '/projects',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },
  // {
  //   label: 'Test',
  //   path: '/publications',
  // },
];

export default routes;
